module.exports = __webpack_public_path__ + "static/mdxdeck-f45f11d8664b5c341f397c9cda66b180.png";